import { render, staticRenderFns } from "./industry.vue?vue&type=template&id=b508d308&scoped=true"
import script from "./industry.vue?vue&type=script&lang=js"
export * from "./industry.vue?vue&type=script&lang=js"
import style0 from "./industry.vue?vue&type=style&index=0&id=b508d308&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_j7fuxwmg3pjjrof4ryv5g7uhre/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b508d308",
  null
  
)

export default component.exports